import React from "react";

const CandidateMarkAsUnsuitableIcon = ({ cls }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M1.875 1.875C1.875 0.83925 2.71425 0 3.75 0C4.78575 0 5.625 0.83925 5.625 1.875C5.625 2.91075 4.78575 3.75 3.75 3.75C2.71425 3.75 1.875 2.91075 1.875 1.875ZM6 12.3472V17.25C6 17.6647 5.664 18 5.25 18C4.836 18 4.5 17.6647 4.5 17.25V12.75H3V17.25C3 17.6647 2.664 18 2.25 18C1.836 18 1.5 17.6647 1.5 17.25V12.3472C0.60375 11.8275 0 10.8585 0 9.75V7.5C0 5.8455 1.3455 4.5 3 4.5H4.5C6.1545 4.5 7.5 5.8455 7.5 7.5V9.75C7.5 10.8585 6.89625 11.8282 6 12.3472ZM6 7.5C6 6.67275 5.32725 6 4.5 6H3C2.17275 6 1.5 6.67275 1.5 7.5V9.75C1.5 10.5773 2.17275 11.25 3 11.25H4.5C5.32725 11.25 6 10.5773 6 9.75V7.5ZM18 12.75C18 15.6442 15.645 18 12.75 18C9.855 18 7.5 15.6442 7.5 12.75C7.5 9.85575 9.855 7.5 12.75 7.5C15.645 7.5 18 9.85575 18 12.75ZM16.5 12.75C16.5 10.6823 14.8177 9 12.75 9C10.6823 9 9 10.6823 9 12.75C9 14.8177 10.6823 16.5 12.75 16.5C14.8177 16.5 16.5 14.8177 16.5 12.75ZM12.75 12.75C13.164 12.75 13.5 12.4148 13.5 12V10.5C13.5 10.0852 13.164 9.75 12.75 9.75C12.336 9.75 12 10.0852 12 10.5V12C12 12.4148 12.336 12.75 12.75 12.75ZM12.75 13.5C12.129 13.5 11.625 14.004 11.625 14.625C11.625 15.246 12.129 15.75 12.75 15.75C13.371 15.75 13.875 15.246 13.875 14.625C13.875 14.004 13.371 13.5 12.75 13.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CandidateMarkAsUnsuitableIcon;
